import { CovidCaseByCountry_covidCaseOwidByCountry_latest } from "../apollo-types/CovidCaseByCountry";

export const FAKE_LAST_DAY: CovidCaseByCountry_covidCaseOwidByCountry_latest = {
  date: "",
  newCases: null,
  newDeaths: null,
  newRecovered: null,
  newActive: null,
  newTests: null,
  totalCases: null,
  totalCasesPerMillion: null,
  totalDeaths: null,
  totalDeathsPerMillion: null,
  totalTests: null,
  totalTestsPerThousand: null,
  totalRecovered: null,
  totalRecoveredPerMillion: null,
  totalActive: null,
  totalActivePerMillion: null,
  averageNewCases: 0,
  averageNewCasesPerMillion: null,
  averageNewDeath: 0,
  averageNewDeathPerMillion: null,
  averageNewTests: null,
  averageNewTestsPerThousand: null,
  averageNewRecovered: null,
  averageNewRecoveredPerMillion: null,
  fatalityRate: null,
  fatalityRateChange: null,
  testsUnits: "",
};
